import { on } from '@ngrx/store';
import { LocalesActions, AsyncActions } from './locales.actions';
import {ItemLocale, Locale, LocaleMappings} from '@emm/core/models/locale.model';
import {withLoadables} from '@emm/core/util/ngrx.util';
import {asyncActionState} from '@emm/core/util/async-action-state';

export const localesFeatureKey = 'locales';

export interface LocalesState {
    attributeLocaleFields: ItemLocale;
    localeMappings: LocaleMappings;
    localeOptions: Locale[];
    localeSelected: Locale;
    origin: string;
    saved: boolean;
}

export const initialState: LocalesState = {
    attributeLocaleFields: {
        description: null,
        jsonProperty: null,
        metadata: {
            localeSupport: null,
            options: [],
            readOnly: null,
            required: null,
            type: null
        },
        name: '',
        tag: '',
        values: []
    },
    localeMappings: {
        countries: {},
        languages: {}
    },
    localeOptions: [],
    localeSelected: {
        country: 'US',
        language: ''
    },
    origin: null,
    saved: false,
    ...asyncActionState.initial
};

const { loadActions, successActions, errorActions } = AsyncActions;

export const localesReducer = withLoadables<LocalesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(LocalesActions.localeInit, (state: LocalesState) => ({
        ...state,
        localeSelected: state && state.localeOptions.length && state.localeOptions[0]
    })),

    on(LocalesActions.loadLocaleOptionsSuccess, (state: LocalesState, { localeOptions }) => ({
        ...state,
        localeOptions,
        localeSelected: localeOptions[0]
    })),

    on(LocalesActions.resetSaved, (state: LocalesState) => ({
        ...state,
        origin: null,
        saved: false
    })),

    on(LocalesActions.saveAttributeLocaleFields, (state: LocalesState, { origin }) => ({
        ...state,
        origin,
        saved: true
    })),

    on(LocalesActions.saveAttributeLocaleFieldsSuccess, (state: LocalesState) => ({
        ...state
    })),

    on(LocalesActions.loadLocaleMappingsSuccess, (state: LocalesState, { localeMappings }) => ({
        ...state,
        localeMappings
    })),

    on(LocalesActions.loadAttributeLocaleFieldsSuccess, (state: LocalesState, { attributeLocaleFields }) => ({
        ...state,
        attributeLocaleFields
    })),

    on(LocalesActions.selectedLocale, (state: LocalesState, { locale }) => ({
        ...state,
        localeSelected: locale
    }))

);
